import React, { createContext, useContext, RefObject } from 'react';

interface LayoutContextType {
  mainScrollRef: RefObject<HTMLElement> | null;
}

const LayoutContext = createContext<LayoutContextType>({ mainScrollRef: null });

export const useLayoutContext = () => useContext(LayoutContext);

export const LayoutProvider = LayoutContext.Provider; 